import Vue from 'vue'
Vue.directive('longpress', function (el, binding) {
    var timer = null;
    var start = function (e) {
        // 如果是点击事件，不启动计时器，直接返回
        if (e.type === 'click') {
            return
        }
        if (timer == null) {

            // 创建定时器 ( 2s之后执行长按功能函数 )
            timer = setTimeout(function () {
                //执行长按功能函数
                binding.value.handleLongClick(binding.value.item)
            }, 1000)
        }
    }
    var cancel = function () {
        if (timer !== null) {
            clearTimeout(timer)
            timer = null
        }
    }
    // 添加事件监听器
    el.addEventListener("mousedown", start);
    el.addEventListener("touchstart", start);

    // 取消计时器
    el.addEventListener("click", cancel);
    el.addEventListener("mouseout", cancel);
    el.addEventListener("touchend", cancel);
    el.addEventListener("touchcancel", cancel);
})
const windowHeight = window.innerHeight
// 弹起输入框，固定页面定位（ios问题）
Vue.directive('fixedInput', function (el, binding) {
  el.addEventListener('blur', function () {
    let windowFocusHeight = window.innerHeight
    if (windowHeight == windowFocusHeight) {
      return
    }
    let currentPosition;
    let speed = 1; //页面滚动距离
    currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
    currentPosition -= speed;
    window.scrollTo(0, currentPosition); //页面向上滚动
    currentPosition += speed; //speed变量
    window.scrollTo(0, currentPosition); //页面向下滚动
  })
})

Vue.directive('scrollShow',function(el){
   setTimeout(() => {
       
    window.addEventListener('scroll', () => {
     
           if (document.documentElement.scrollTop  > el.offsetTop) {
               console.log(el);
               for (let i = 0; i < el.children.length; i++) {
                   setTimeout(() => {
                       el.children[i].style.display = 'block'
                   }, 1000 * i)
               }
           }
       })
   }, 300);
  
})